import type { ApiClient } from './client';

// ANX-069 — «Кто сейчас на сайте». Снапшот живых визитёров (polling) +
// «написать первым».

export interface LiveVisitor {
  visitorId: string;
  page?: string;
  lastSeen: string;
  name?: string;
  email?: string;
  /** id открытого диалога визитёра, если есть. */
  conversationId?: string;
}

interface RawLiveVisitor {
  visitor_id: string;
  page?: string;
  last_seen: string;
  name?: string;
  email?: string;
  conversation_id?: string;
}

// ANX-103 — счётчики активности за окна. `now` — сколько визитёров прямо
// сейчас на сайте (живых), остальные — уникальные визитёры за окно.
export interface LiveVisitorCounts {
  now: number;
  last5min: number;
  lastHour: number;
  today: number;
}

export interface LiveVisitorsSnapshot {
  visitors: LiveVisitor[];
  counts: LiveVisitorCounts;
}

interface RawCounts {
  now?: number;
  last_5min?: number;
  last_hour?: number;
  today?: number;
}

export async function listLiveVisitors(client: ApiClient): Promise<LiveVisitorsSnapshot> {
  // tz — для счётчика «сегодня» (начало дня в таймзоне оператора), как heatmap.
  let tz = 'UTC';
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    tz = 'UTC';
  }
  const raw = await client.request<{ visitors: RawLiveVisitor[]; counts?: RawCounts }>(
    `/api/v1/live-visitors?tz=${encodeURIComponent(tz)}`,
  );
  const visitors = raw.visitors.map((v) => {
    const lv: LiveVisitor = { visitorId: v.visitor_id, lastSeen: v.last_seen };
    if (v.page) lv.page = v.page;
    if (v.name) lv.name = v.name;
    if (v.email) lv.email = v.email;
    if (v.conversation_id) lv.conversationId = v.conversation_id;
    return lv;
  });
  const c = raw.counts ?? {};
  const counts: LiveVisitorCounts = {
    now: c.now ?? visitors.length,
    last5min: c.last_5min ?? 0,
    lastHour: c.last_hour ?? 0,
    today: c.today ?? 0,
  };
  return { visitors, counts };
}

/** «Написать первым»: создаёт/открывает диалог визитёра и шлёт ему сообщение
 *  от оператора. Возвращает id диалога для навигации. */
export async function sendOutreach(
  client: ApiClient,
  visitorId: string,
  body: string,
): Promise<{ conversationId: string }> {
  const raw = await client.request<{ conversation_id: string }>(
    `/api/v1/visitors/${visitorId}/outreach`,
    { method: 'POST', json: { body } },
  );
  return { conversationId: raw.conversation_id };
}
